import { FC } from 'react';
import type { SubscriptionLine } from '../../types/constant/SubscriptionType';
import type { SubscriptionProductViewItem } from '../../utils/subscriptionDetail/types';

type Props = {
  subscribedItems: SubscriptionProductViewItem[] | null | undefined;
  fallbackLines: SubscriptionLine[];
  productDisplayUnits: Record<string, string>;
  /** PAUSED 行などグレーアウト用 */
  grayedOut?: boolean;
};

/**
 * マイアカTOPの契約1件ぶんのサムネ。
 * subscribedItems があれば詳細の「次回お届け」と同じ単位、なければ従来どおり subscriptionLines。
 */
export const SubscriptionListProductThumbnails: FC<Props> = ({
  subscribedItems,
  fallbackLines,
  productDisplayUnits,
  grayedOut = false,
}) => {
  const imgClass = grayedOut
    ? 'subscription-history__itemimg grayoutItemimg'
    : 'subscription-history__itemimg';
  const countClass = grayedOut
    ? 'subscription-history__itemcount grayoutItemimg'
    : 'subscription-history__itemcount';

  const useSubscribed = subscribedItems != null && subscribedItems.length > 0;

  if (useSubscribed) {
    return (
      <>
        {subscribedItems!.map((item) => {
          if (item.type === 'product') {
            const p = item.product;
            const unit =
              (p.productId && productDisplayUnits[p.productId]) || p.displayUnit || '袋';
            return (
              <div
                className="subscription-history__item"
                key={p.lineId}
              >
                <img
                  src={p.variantImage}
                  alt=""
                  width={80}
                  height={80}
                  className={imgClass}
                />
                <p className={countClass}>
                  ×
                  <span className="subscription-history__itemcountQty">{p.quantity}</span>
                  <span className="subscription-history__itemcountUnit">{unit}</span>
                </p>
              </div>
            );
          }

          const { parent, items } = item.box;
          const unit =
            (parent.productId && productDisplayUnits[parent.productId]) ||
            parent.displayUnit ||
            '袋';
          // まとめ買いは1マスにまとめるため、内訳の合計を出す（全件同数のときも first 1つ分にしない）
          const qty =
            items.length === 0 ? 0 : items.reduce((sum, i) => sum + i.quantity, 0);

          return (
            <div
              className="subscription-history__item"
              key={parent.id}
            >
              <img
                src={parent.variantImage}
                alt=""
                width={80}
                height={80}
                className={imgClass}
              />
              <p className={countClass}>
                ×
                <span className="subscription-history__itemcountQty">{qty}</span>
                <span className="subscription-history__itemcountUnit">{unit}</span>
              </p>
            </div>
          );
        })}
      </>
    );
  }

  return (
    <>
      {fallbackLines.map((subscriptionLine, index) => {
        const displayUnit = subscriptionLine.productId
          ? productDisplayUnits[subscriptionLine.productId] || '袋'
          : '袋';
        return (
          <div
            className="subscription-history__item"
            key={subscriptionLine.lineId || String(index)}
          >
            <img
              src={subscriptionLine.variantImage ?? ''}
              alt=""
              width={80}
              height={80}
              className={imgClass}
            />
            <p className={countClass}>
              ×
              <span className="subscription-history__itemcountQty">{subscriptionLine.quantity}</span>
              <span className="subscription-history__itemcountUnit">{displayUnit}</span>
            </p>
          </div>
        );
      })}
    </>
  );
};
